import React from 'react';
import NumberFormat from 'react-number-format';
import RenderValidateMessage from '../Validation/RenderValidateMessage';
import { Form } from 'react-bootstrap';

export default function DateOfBirthInput(props) {
    const { label, errors, setDOB, dateOfBirth, handleEnter, required = false } = props;

    return (
        <Form.Group>
            <Form.Label>{required && <span className="text-danger">*</span>} {label}</Form.Label>
            <NumberFormat
                mask="_"
                name="dateOfBirth"
                value={dateOfBirth}
                format="##/##/####"
                className="form-control"
                onKeyDown={handleEnter}
                placeholder="__/__/____"
                onValueChange={e => setDOB({ dateOfBirth: e.formattedValue })}
            />
            <RenderValidateMessage errors={errors} field="dateOfBirth" />
        </Form.Group>

    )
}
